const SpeakerData27 = [
  {
    name: "Coming Soon!",
    role: "",
    description: `Keynote speaker details coming soon!.`,
    isKeynote: true,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Keynote speaker details coming soon!.`,
    isKeynote: true,
    ytData: [],
  },

  {
    name: "Christie Summervill",
    role: "Chief Executive Officer, BalancedComp",
    description: `With over 25 years of experience, Christie Summervill, CEO and Principal of BalancedComp, has helped organizations design competitive salary structures, incentive plans, performance management systems, and total rewards strategies that drive talent retention, regulatory compliance, and business performance. A sought-after speaker and conference host (FINCOMP), she delivers practical, data-driven insights on emerging compensation trends, pay transparency, and aligning rewards with strategic goals. Her HRCI/SHRM-accredited webinars and client-focused sessions are known for translating`,
    ytData: [
      {
        img: "",
        id: "",
        title:
          "From Benchmark to Business Impact: Essential Insights and Salary Trends for Compensation Leaders",
        date: "",
        time: "",
        description: `Christie Summervill, CEO and Principal of BalancedComp, LLC, brings over 25 years of compensation consulting experience to help financial institutions design effective salary structures, incentives, performance management programs and CEO compensation plans. In this session, she will explore the latest shifts in pay strategies that are quietly revolutionizing the banking world. We’ll break down how to stay competitive without breaking the budget (or your CFO’s heart). Expect practical insights on aligning pay with performance, keeping regulators happy, and yes, finally answering that eternal question: “Are we paying enough… or just enough to lose them slowly?” You’ll leave armed with data, strategies, and just enough sass to defend your next comp plan with a straight face and a strong case.`,
      },
    ],
  },

  {
    name: "Philippe Asselin",
    role: "Chief Consultant, BalancedComp",
    description: `Philippe Asselin brings together operational leadership, financial institution expertise, and compensation strategy to help financial institutions build high-performing organizations. Having worked with hundreds of financial institutions nationwide, Philippe is known for helping leadership teams simplify complex compensation decisions, align incentives with performance, and create systems that scale. His background spans executive leadership in hospitality, banking, and FinTech—giving him a practical understanding of how compensation impacts culture, accountability, and organizational growth. Today, at BalancedComp, Philippe partners with FI's to build smarter, more effective programs that support both people and performance.`,
    ytData: [
      {
        img: "",
        id: "",
        title: "The Truth Problem in Compensation Philosophy",
        date: "Tuesday, June 9",
        time: "11:15 am - 11:45 am",
        description: `This presentation explores why compensation philosophies in banks and credit unions often fail to drive engagement, trust, and long-term sustainability when they lose alignment with objective market data, measurable performance standards, organizational culture, and financial realities. Attendees will learn how transparency, communication, adaptability, operational efficiency, and continuously evolving variable pay strategies can strengthen total rewards programs while supporting retention, performance, and institutional sustainability. Designed for executive and HR leaders, this session provides practical frameworks and strategic insights for building compensation philosophies that remain credible, competitive, and sustainable in rapidly changing labor and economic environments.`,
      },
    ],
  },

  {
    name: "Crystal Hughes",
    role: "Consultant, BalancedComp",
    description: `Crystal Hughes is a Compensation Consultant at BalancedComp, a specialized HR consulting firm dedicated to serving banks and credit unions nationwide. With over five years of experience in strategic business planning for small businesses, Crystal brings a passionate, client-focused approach to compensation consulting. She excels at interpreting market data and helping financial institutions make informed, strategic HR decisions that align compensation practices with organizational goals, employee advocacy, and long-term success. In addition to her consulting work, Crystal is an active contributor to industry insights through her writing. Her blog articles include “Why Hire a Compensation Consultant?” and “Fixing Title Confusion: A Case for Job.”`,
    ytData: [
      {
        img: "",
        id: "",
        title:
          "From Reluctant to Remarkable: HR Leaders Panel - How to Get Supervisors to Deliver Powerful Performance Reviews",
        date: "",
        time: "",
        description: `This panel brings together experienced HR executives to openly share their real-world struggles and hard-earned successes in getting supervisors and managers to deliver effective, meaningful performance reviews. Rather than focusing on templates or theory, the discussion dives into the practical challenges—resistance, lack of skills, time constraints, and discomfort—and the proven strategies these leaders used to drive real behavior change across their organizations. Attendees will hear candid stories, actionable tactics, and interactive Q&A, making this a highly practical session designed for HR professionals who want to move beyond frustration to measurable improvement in performance management.`,
      },
    ],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },
];

export default SpeakerData27;
